export function showAdvisoryTextSectionF(context: any, values: any): boolean {
  const screening = values.applicationBase != null ? values.applicationBase.screeningQuestions : values;
  const applicationCategory = screening.fundedKinder.consentYes.applicationCategory;
  const complexMedicalNeedsCriteria = screening.fundedKinder.consentYes.complexMedicalNeedsCriteria;

  const isComplexMedical = applicationCategory === 3 && complexMedicalNeedsCriteria === 1;

  const isDisability = applicationCategory === 1 && !ValidateDisabilityAndPlan(screening);

  const isComplexAndDisability = applicationCategory === 2 && complexMedicalNeedsCriteria === 1 && !ValidateDisabilityAndPlan(screening);

  if (isComplexMedical || isDisability || isComplexAndDisability) {
    return true;
  } else {
    return false;
  }
}

export function showAdvisoryTextSectionG(context: any, values: any): boolean {
  const screening = values.applicationBase != null ? values.applicationBase.screeningQuestions : values;

  const applicationCategory = screening.fundedKinder.consentYes.applicationCategory;
  const complexMedicalNeedsCriteria = screening.fundedKinder.consentYes.complexMedicalNeedsCriteria;
  // Case 1: Complex Medical Needs and can't upload documents
  if (
    (applicationCategory === 3 && complexMedicalNeedsCriteria === 2) ||
    // Case 2: Disability (including developmental delay) with specific conditions
    (applicationCategory === 1 && validateDisability(screening)) ||
    // Case 3: Both Complex Medical Needs and Disability with specific conditions
    (applicationCategory === 2 && complexMedicalNeedsCriteria === 2 && validateDisability(screening))
  ) {
    return true;
  }

  return false;
}

export function showAdvisoryTextSectionH(context: any, values: any): boolean {
  const screening = values.applicationBase != null ? values.applicationBase.screeningQuestions : values;
  const applicationCategory = screening.fundedKinder.consentYes.applicationCategory;
  const complexMedicalNeedsCriteria = screening.fundedKinder.consentYes.complexMedicalNeedsCriteria;

  // Case 1: Both Complex Medical Needs and Disability (including developmental delay) and can't upload documents
  if (applicationCategory === 2 && complexMedicalNeedsCriteria === 2 && !ValidateDisabilityAndPlan(screening)) {
    return true;
  }
  return false;
}

export function showAdvisoryTextSectionI(context: any, values: any): boolean {
  const screening = values.applicationBase != null ? values.applicationBase.screeningQuestions : values;
  const applicationCategory = screening.fundedKinder.consentYes.applicationCategory;
  const complexMedicalNeedsCriteria = screening.fundedKinder.consentYes.complexMedicalNeedsCriteria;

  // Case 1: Complex Medical Needs and can't upload documents
  if (applicationCategory === 2 && complexMedicalNeedsCriteria === 1 && validateDisability(screening)) {
    return true;
  }

  return false;
}

export function showAdvisoryTextSectionP(context: any, values: any): boolean {
  const screening = values.applicationBase != null ? values.applicationBase.screeningQuestions : values;
  const applicationCategory = screening.fundedKinder.consentYes.applicationCategory;
  const complexMedicalNeedsCriteria = screening.fundedKinder.consentYes.complexMedicalNeedsCriteria;

  // Case 1: Complex Medical Needs and can't upload documents
  if (
    (applicationCategory === 3 && complexMedicalNeedsCriteria === 2) ||
    // Case 2: Disability (including developmental delay) with specific conditions
    (applicationCategory === 1 && validateDisability(screening)) ||
    // Case 3: Both Complex Medical Needs and Disability with specific conditions
    (applicationCategory === 2 && complexMedicalNeedsCriteria === 2 && validateDisability(screening))
  ) {
    return true;
  }

  return false;
}

export function showAdvisoryTextSectionR(context: any, values: any): boolean {
  const screening = values.applicationBase != null ? values.applicationBase.screeningQuestions : values;
  const applicationCategory = screening.fundedKinder.consentYes.applicationCategory;
  const complexMedicalNeedsCriteria = screening.fundedKinder.consentYes.complexMedicalNeedsCriteria;

  if (applicationCategory === 2 && complexMedicalNeedsCriteria === 1 && validateDisability(screening)) {
    return true;
  }
  return false;
}

export function validateDisability(values: any) {
  return (
    values.fundedKinder.consentYes.childsDisability.childsDisabilityNone == true ||
    (values.fundedKinder.consentYes.childDiagnosedDisability != null && values.fundedKinder.consentYes.childDiagnosedDisability === 3) ||
    (values.fundedKinder.consentYes.childDiagnosedDisability != null &&
      values.fundedKinder.consentYes.childDiagnosedDisability === 1 &&
      values.fundedKinder.consentYes.typeOfDiagnosedDisabilityEvidence != null &&
      values.fundedKinder.consentYes.typeOfDiagnosedDisabilityEvidence === 4) ||
    (values.fundedKinder.consentYes.childDiagnosedDisability != null &&
      values.fundedKinder.consentYes.childDiagnosedDisability === 2 &&
      values.fundedKinder.consentYes.evidenceUndergoingAssessment != null &&
      values.fundedKinder.consentYes.evidenceUndergoingAssessment === 3) ||
    (values.fundedKinder.consentYes.kisPlanCompleted != null && values.fundedKinder.consentYes.kisPlanCompleted === 2)
  );
}

export function ValidateDisabilityAndPlan(values: any) {
  return (
    values.fundedKinder.consentYes.childsDisability.childsDisabilityNone == true ||
    values.fundedKinder.consentYes.childDiagnosedDisability == null ||
    values.fundedKinder.consentYes.childDiagnosedDisability === 3 ||
    (values.fundedKinder.consentYes.childDiagnosedDisability === 1 &&
      (values.fundedKinder.consentYes.typeOfDiagnosedDisabilityEvidence == null ||
        values.fundedKinder.consentYes.typeOfDiagnosedDisabilityEvidence === 4)) ||
    (values.fundedKinder.consentYes.childDiagnosedDisability === 2 &&
      (values.fundedKinder.consentYes.evidenceUndergoingAssessment === null || values.fundedKinder.consentYes.evidenceUndergoingAssessment === 3)) ||
    values.fundedKinder.consentYes.kisPlanCompleted == null ||
    values.fundedKinder.consentYes.kisPlanCompleted === 2
  );
}
